import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import messagesApi from '../../api/messages_api';
import { chatSocket } from '../../api/chatSocket';

/*
 * Live unread total for the Messages nav entry: fetched on mount and every
 * route change (so it updates after reading conversations), plus a coalesced
 * refetch whenever the server pushes a chat:unread nudge.
 */
export default function useUnreadBadge() {
  const location = useLocation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let alive = true;
    messagesApi
      .unreadCount()
      .then((res) => {
        if (alive) setCount(Number(res && res.total) || 0);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [location.key]);

  useEffect(() => {
    let timer = null;
    const off = chatSocket.on('chat:unread', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        messagesApi
          .unreadCount()
          .then((res) => setCount(Number(res && res.total) || 0))
          .catch(() => {});
      }, 250);
    });
    return () => {
      off();
      clearTimeout(timer);
    };
  }, []);

  return count;
}
